function correctCardHeight() {
    let storie = document.querySelector('.storie-cards');
    if (storie && screen.width > 768) {
        let cards = storie.querySelectorAll('.item-scroll-teaser');
        for (let i = 0; i < cards.length; i++) {
            if ((i % 2 != 0 && window.innerWidth >= 992)) {
                cards[i].style.setProperty('min-height', '200px');
                cards[i].style.setProperty('height', '200px');
                let icon = cards[i].querySelector('.icn-det');
                icon.style.setProperty('margin-top', '140px');
                let head_image = cards[i].parentElement.querySelector('[name=cover-image]');
                if (head_image) {
                    cards[i].style.setProperty('background-image', 'url(' + head_image.querySelector('div').getAttribute('data-desktop') + ')');
                }
            }
        }
    }
}
function correctColumn() {
    let storie_section = document.querySelector('.storie-teaser-section');
    if (storie_section && screen.width > 768) {
        storie_section.querySelector('.teaser-extended-card').style.setProperty('max-width', '600px');
        storie_section.querySelector('.teaser-cards').style.setProperty('overflow-y', 'auto');
        storie_section.querySelector('#storie_cards_container').style.setProperty('display', 'flex');
        storie_section.querySelector('#storie_cards_container').style.setProperty('flex-wrap', 'wrap');
        storie_section.querySelector('#storie_cards_container').style.setProperty('gap', '20px');
        let cards = storie_section.querySelectorAll('.campaign-item.storie');
        for (let i = 0; i < cards.length; i++) {
            cards[i].style.setProperty('flex', '1 1 300px');
            cards[i].style.setProperty('max-width', '300px');
        }
        cards = storie_section.querySelectorAll('.item-scroll-teaser');
        for (let i = 0; i < cards.length; i++) {
            cards[i].style.setProperty('min-height', '200px');
            cards[i].style.setProperty('height', '200px');
            cards[i].style.setProperty('width', '300px');
            let icon = cards[i].querySelector('.icn-det');
            icon.style.setProperty('margin-top', '140px');
            icon.style.setProperty('margin-left', '240px');
            let head_image = cards[i].parentElement.querySelector('[name=cover-image]');
            if (head_image) {
                cards[i].style.setProperty('background-image', 'url(' + head_image.querySelector('div').getAttribute('data-desktop') + ')');
            }
        }
    }
}
const storie_num_columns = document.querySelector('#storie_num_columns');
if (storie_num_columns && storie_num_columns.value == "3")
    window.addEventListener('load', correctColumn);
else
    window.addEventListener('load', correctCardHeight);
if (document.querySelector('.clickable')) {
    const link = document.querySelector('.clickable').querySelector('a[href]');
    document.querySelector('.clickable').addEventListener('click', (event) => {
        event.preventDefault();
        window.location.href = link.href;
    });
}
if (storie_num_columns && storie_num_columns.value != "3" && document.querySelector('.teaser-cards')) {
    const section = document.querySelector('.storie-teaser-section');
    const teaserCards = document.querySelector('.teaser-cards');
    let scrollingteaserCards = false;
    let previousOffsetY = 0;
    function isMouseOverteaserCardsSection(e) {
        return (window.pageYOffset >= teaserCards.offsetTop &&
            window.pageYOffset <= teaserCards.offsetTop + teaserCards.offsetHeight);
    }
    window.addEventListener('scroll', function (e) {
        if (isMouseOverteaserCardsSection(e)) {
            e.preventDefault();
            scrollingteaserCards = true;
        }
        else {
            scrollingteaserCards = false;
        }
        if (!scrollingteaserCards) {
            window.scrollTo({
                top: window.scrollY + (window.scrollY - window.pageYOffset),
                behavior: 'smooth',
            });
        }
        else {
            var delta = 0;
            if (window.pageYOffset > previousOffsetY) {
                delta = 40;
            }
            else {
                delta = -40;
            }
            teaserCards.scrollTop += delta;
            previousOffsetY = window.pageYOffset <= 0 ? 0 : window.pageYOffset;
        }
    }, { passive: false });
}
